import ManagementWrapper from './ManagementWrapper';

export default ManagementWrapper;
